<template>
  <div class="row_center_between process_bar">
    <div class="row_center_center h-11 px-5 py-2.5 bg-white rounded-[30px] mr-[30px] shrink-0" @click="toStore">
      <text class="method" v-if="geturlParameters.method === 'dineIn'">{{ tableName ? `桌號：${tableName}` : '門市內用' }}</text>
      <text class="method" v-if="geturlParameters.method === 'takeOut'">{{ tableName ? `現場外帶：${tableName}` : '現場外帶' }}</text>
      <text class="method" v-if="geturlParameters.method === 'pickUp'">預約自取</text>
      <text class="method" v-if="geturlParameters.method === 'delivery'">店家外送</text>
    </div>
    <div class="row_center_center">
      <text class="step" :class="{ active_step: geturlParameters.process === 'ordering' }">選擇餐點</text>
      <img src="@/assets/grayTriangle.png" style="width: 5px; height: 7px; margin: 0 5px" />
      <text class="step" :class="{ active_step: geturlParameters.process === 'orderConfirm' }">確認訂單</text>
      <img src="@/assets/grayTriangle.png" style="width: 5px; height: 7px; margin: 0 5px" />
      <text class="step" :class="{ active_step: geturlParameters.process === 'orderPayment' }">付款</text>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    geturlParameters() {
      return this.$route.params
    },
    tableName() {
      return this.$store.getters['cart/tableName']
    },
    storeCode() {
      return this.$store.getters['userData/storeCode']
    }
  },
  methods: {
    toStore() {
      this.$router.push({ name: 'onlineOrder', params: { store: this.storeCode } })
    },
  },
}
</script>
<style lang="scss">
.process_bar {
  background-color: #F0F0F0;
  padding: 10px 20px 10px 10px;
  width: 100%;
  height: 64px;
  overflow-y: hidden;
  overflow-x: auto;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.process_bar::-webkit-scrollbar {
  display: none;
}

.step {
  margin-top: 5px;
  font-size: 20px;
  color: #999999;
  padding-bottom: 5px;
  white-space: nowrap;
  // flex-shrink: 0;
}

.active_step {
  color: #000;
  font-weight: 700;
  border-bottom: 1px dotted #000;
}

.method {
  color: #fd5001;
  font-size: 18px;
  font-weight: 500;
  flex-shrink: 0;
}</style>
